import { useState, useEffect, useRef } from "react";
import { verifyEmailChange } from "../api/authApi";

export const useEmailChangeTokenValidation = (token) => {
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const hasValidated = useRef(false);

  useEffect(() => {
    if (!token || hasValidated.current) return;

    const validateToken = async () => {
      hasValidated.current = true;
      setIsLoading(true);

      try {
        const res = await verifyEmailChange(token);
        setResult({ success: true, email: res.email });
      } catch (error) {
        setResult({ success: false, error });
      } finally {
        setIsLoading(false);
      }
    };

    validateToken();
  }, [token]);

  return { result, isLoading };
};